import {HibuUiConfiguration} from './config-types';
import {ConfigAction} from './config-actions';
import {TabType} from '../search/search-types';

const initialState: HibuUiConfiguration = {
    keycloakConfig: {
        enabled: false,
        url: '',
        realm: '',
        clientId: '',
    },
    landingPage: {
        enabled: false
    },
    languageSwitcher: {
        enabled: false
    },
    sharedSavedSearches: {
        enabled: false
    },
    search: {
        enabled: false,
        resultListFields: {
            title: [],
            titleSeparator: ' | ',
            main: [],
            mainSeparator: ' | ',
            sub: [],
            subSeparator: ' | ',
            showFileTypeIcons: true,
        },
        enabledDetailsTabs: [TabType.CONTENT, TabType.SPOTLIGHT, TabType.CONTENT],
        spotlightTagTypes: [],
        detailFields: {
            detailTagTypes: [],
            detailMetadata: []
        },
        export: {
            enabled: false,
            toggles: {
                html: false,
                json: false
            }
        },
        tagsWithDropdown: [],
        tagDropdownOptions: {},
        tagsWithConfirmation: [],
        documentActions: {
            toggles: {
                showLinkToClipboardButton: true,
                showLinkByMailButton: true,
                showDownloadButton: true,
            }
        }
    },
    analysis: {
        enabled: false
    },
    settings: {
        enabled: false,
        toggles: {
            showUserId: false,
            showContainerName: false,
            showTechnicalDetails: false,
            showManualValidation: false,
            showFieldSpecificSearch: false,
        }
    },
    styleVariables: {},
    logoUrl: undefined,
    menuItems: []
};

const applyStyles = (styleVariables: Record<string, string>) => {
    // set all styles from backend
    if (styleVariables) {
        Object.entries(styleVariables).forEach((entry) => {
            document.documentElement.style.setProperty('--' + entry[0], entry[1]);
        });
    }
};

export function configReducer(state: HibuUiConfiguration = initialState, action: ConfigAction): HibuUiConfiguration {
    switch (action.type) {
        case 'CONFIG_LOAD_FINISHED': {
            applyStyles(action.config.styleVariables);
            return {
                ...action.config,
            };
        }
        case 'CONFIG_LOAD_TAG_OPTIONS_FINISHED': {
            state.search.tagDropdownOptions = action.tagOptions;
            return state;
        }
        default:
            return state;
    }
}
